module.exports = "data:text/x-markdown;base64,IyMge3sgZmllbGQubmFtZSB9fQoKYHt7IGZpZWxkLm5hbWUgfX1gIGlzIGEgYHN0cmluZ2AgZmllbGQuIEV4YW1wbGUgcXVlcnk6CgpgYGAKU0VMRUNUICogRlJPTSB7eyB0YWJsZSB9fSBXSEVSRSB7eyBmaWVsZC5uYW1lIH19ID0gJ3t7IGZpZWxkLnNhbXBsZSB9fScKYGBgCiAKIyMjIFBhcnRpYWwgbWF0Y2hlcwpVc2UgYExJS0VgIGFuZCB0aGUgYCVgIHdpbGRjYXJkIGNoYXJhY3RlciBpbnNpZGUgYSBzdHJpbmcgdG8gZmluZCBwYXJ0aWFsIG1hdGNoZXMuCgpgYGAKU0VMRUNUICogV0hFUkUge3sgZmllbGQubmFtZSB9fSBMSUtFICd7eyBmaWVsZC5zYW1wbGUuc3Vic3RyKDAsIGZpZWxkLnNhbXBsZS5sZW5ndGggLyAyKSB9fSUnCmBgYAoK"


//////////////////
// WEBPACK FOOTER
// ./src/content/string-field.md
// module id = 316
// module chunks = 0